const { getDate, getTimeOptions } = require('@/views/fusion/investment/intelligence-create/tools');
import { TIME_PERIOD_LENGTH } from '@/enums';

const schedule_type = {
  label: '投放日期',
  type: 'radio-group',
  isButton: true,
  options: [
    { label: '长期投放', value: 'SCHEDULE_FROM_NOW' },
    { label: '指定日期', value: 'SCHEDULE_START_END' },
  ],
  rules: {
    required: true,
    message: '请选择投放日期类型',
    trigger: ['change'],
  },
  value: 'SCHEDULE_FROM_NOW',
};

const delivery_date = {
  label: ' ',
  type: 'date-picker',
  hidden: true,
  rules: { required: true, message: '请选择日期', trigger: ['change'] },
  props: {
    type: 'daterange',
    valueFormat: 'yyyy-MM-dd',
    startPlaceholder: '请选择开始日期',
    endPlaceholder: '请选择结束日期',
    pickerOptions: {
      // 禁选当天之前的日期
      disabledDate(time) {
        return time.getTime() < Date.now() - 8.64e7;
      },
    },
  },
  value: [
    (() => getDate())(),
    (() => getDate(7))(),
  ],
};

const time_period_type = {
  label: '投放时间',
  type: 'radio-group',
  isButton: true,
  hidden: false,
  options: [
    { label: '全天', value: 'TIME_PERIOD_ALL' },
    { label: '指定时间', value: 'TIME_PERIOD_DAY_SPECIFIC' },
    { label: '指定多个时间', value: 'TIME_PERIOD_HOUR_SPECIFIC' },
  ],
  value: 'TIME_PERIOD_ALL',
};

const schedule_time = {
  label: ' ',
  type: 'form-range',
  hidden: true,
  value: { start: '', end: '' },
  props: {
    startOptions: getTimeOptions(0, 23, true),
    endOptions: getTimeOptions(1, 24, true),
  },
  rules: {
    required: true,
    trigger: ['change'],
    validator: (_, value, callback) => {
      if (!(value.start === 0 || value.start) || !value.end) {
        callback(new Error('请选择时间'));
      } else if (value.start > value.end || value.start === value.end) {
        callback(new Error('开始时间不可大于或等于结束时间'));
      } else {
        callback();
      }
    },
  },
};

const time_period = {
  label: ' ',
  hidden: true,
  isPreview: false,
  value: { schedule_time_content: new Array(TIME_PERIOD_LENGTH.HALF_HOUR).fill(1).join('') },
};

/**
 * 广告：广告排期配置
 */
export {
  schedule_type, // 投放日期类型
  delivery_date, // 投放日期：[开始投放日期，结束投放日期]
  time_period_type, // 投放时间
  schedule_time, // 指定时间
  time_period, // 指定多个时间
};
